import React from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

const CopyIDIcon: React.FC<{ id: string; size?: SizeProp }> = ({ id, size }) => {
  const className =
    'text-neutral-600 cursor-pointer hover:text-primary-400 hover:bg-primary-100 p-1 rounded-md flex justify-center items-center';

  return (
    <span
      className={twMerge(className, size ? '' : 'h-8 w-8')}
      onClick={e => {
        e.stopPropagation();
        navigator.clipboard.writeText(id);
        toast('Copied to clipboard', {
          type: 'info',
          autoClose: 1000,
          position: 'bottom-right',
        });
      }}
    >
      <FontAwesomeIcon icon={['far', 'copy']} size={size} />
    </span>
  );
};

export default CopyIDIcon;
